import { MutationKeyConfig } from './api-helper';


export const inspectorApiKeyStore = {
  inspectionsEvents: (): MutationKeyConfig => ({
    mutationKey: [`INSPECTOR_EVENTS`],
    route: `/WorkOrder/GetInspectorCalendar`,
    action: 'POST',
    disableSnackbar: true,
  }),
};
